import React, {useState} from 'react';
import {Button, Popover} from "antd";
import {useDispatch} from "react-redux";
import {deleteTableColumn} from "../../redux-store/dynamicTable";
import trashIcon from "../../images/bin.svg";

function DeleteColumnButton({id,tableId}) {

    const [show, setShow] = useState(false)
    const dispatch = useDispatch()

    const content = () => {

        const handleDelete = async () => {
            dispatch(deleteTableColumn({tableId, id}))
            setShow(false)
        }

        return (
            <>
                <Button onClick={handleDelete} className={"btn-save-antd"}>Potvrdi</Button>
                <Button onClick={() => {
                    setShow(false)
                }} className={"btn-cancel-antd"}>Otkaži</Button>
            </>
        )
    }

    return (
        <Popover visible={show} content={content} title="Brisanje"
                 trigger="click" className={"cursor-button atn-popover-flux"}>
            <Button onClick={() => {
                setShow(true)
            }} className={"btn-cancel-antd"}>Obriši</Button>
        </Popover>
    );
}

export default DeleteColumnButton;